var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-10/12"},[_c('h1',[_vm._v(_vm._s(_vm.title)+":")]),_c('p',{staticClass:"font-Hind font-medium text-base -md:ml-8 ml-4 text-left md:text-xl md:text-justify"},[_vm._v(_vm._s(_vm.flavor)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }